import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CalendarEvent } from '../../models/calendar-event';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarClickEvent } from '../../models/calendar-click-event';
import { CalendarComponent } from '../../components/calendar/calendar.component';

@Component({
  selector: 'app-calendar-demo',
  templateUrl: './calendar-demo.component.html',
  styleUrls: ['./calendar-demo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarDemoComponent implements OnInit {

  protected today: Date = new Date();

  protected currentClickEvent: CalendarClickEvent;

  constructor(protected modalService: NgbModal) { }

  ngOnInit(): void {
  }

  protected dayClicked(calendar: CalendarComponent, event: CalendarClickEvent) {
    //We can access everything here now!
  }

  protected handleEventRequest(startPeriod: Date, endPeriod: Date): CalendarEvent[] {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);

    return [
      {
        label: "Interview Marjolijn Aafjes",
        startDate: new Date(tomorrow.setHours(10, 0, 0, 0)),
        endDate: new Date(tomorrow.setHours(10, 30, 0, 0)),
        faIcon: "user"
      },
      {
        label: "Interview Dirk Venters",
        startDate: new Date(new Date().setHours(11, 30, 0, 0)),
        endDate: new Date(new Date().setHours(12, 0, 0, 0)),
        faIcon: "user"
      },
      {
        label: "Interview Sam Account",
        startDate: new Date(tomorrow.setHours(13, 0, 0, 0)),
        endDate: new Date(tomorrow.setHours(13, 30, 0, 0)),
        faIcon: "user"
      },
      {
        label: "EVT1",
        faIcon: "paper-plane",
        startDate: new Date(new Date().setHours(9, 0, 0, 0)),
        endDate: new Date(new Date().setHours(11, 30, 0, 0))
      },
      {
        label: "EVT2",
        faIcon: "paper-plane",
        startDate: new Date(new Date().setHours(5, 0, 0, 0)),
        endDate: new Date(new Date().setHours(12, 0, 0, 0))
      },
      {
        label: "EVT3",
        faIcon: "paper-plane",
        startDate: new Date(new Date().setHours(5, 0, 0, 0)),
        endDate: new Date(new Date().setHours(11, 0, 0, 0))
      },
      {
        label: "EVT4",
        faIcon: "paper-plane",
        startDate: new Date(new Date().setHours(14, 30)),
        endDate: new Date(new Date().setHours(15, 0))
      },
      {
        label: "Last month",
        startDate: lastMonth,
        endDate: lastMonth
      },
      {
        label: "EVT5",
        startDate: new Date(new Date().setHours(17, 0, 0, 0)),
        endDate: new Date(new Date().setHours(20, 0, 0, 0)),
        data: 1
      },
      {
        label: "duplicate",
        startDate: new Date(new Date().setHours(17, 0, 0, 0)),
        endDate: new Date(new Date().setHours(20, 0, 0, 0)),
        data: 0
      },
      {
        label: "Verjaardag Marjolijn Aafjes",
        faIcon: "birthday-cake",
        startDate: new Date(new Date().setHours(0, 0)),
        endDate: new Date(new Date().setHours(23, 59))
      },
      {
        label: "EVT6",
        startDate: new Date(new Date().setHours(13, 0, 0, 0)),
        endDate: new Date(new Date().setHours(14, 30, 0, 0))
      },
      {
        label: "EVT7",
        startDate: new Date(new Date().setHours(14, 0, 0, 0)),
        endDate: new Date(new Date().setHours(15, 30, 0, 0))
      },
      {
        label: "EVT8",
        startDate: new Date(new Date().setHours(20, 0, 0, 0)),
        endDate: new Date(new Date().setHours(21, 30, 0, 0))
      },
      {
        label: "Two days",
        startDate: new Date(),
        endDate: tomorrow
      }
    ]
  }
}
